import { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import Button from 'components/Button';
import ChallengeCardHorizontal from 'components/ChallengeCardHorizontal';
import { useRouter } from 'next/router';
import { logger } from '../../utils';
import { CType } from '../../models/Contentful/types';
import styles from './challengeListBlade.module.sass';
import { getTagList } from '../../models/Contentful';
import FilterBar from '../../components/ContentList/FilterBar';

interface IButtonTextMap {
  [key: string]: string;
}

const Tab = {
  PAST: 'past',
  CURRENT: 'current',
  FUTURE: 'future',
};

const ButtonTextMap: IButtonTextMap = {
  [Tab.FUTURE]: 'Upcoming Challenges',
  [Tab.CURRENT]: 'Current Challenges',
  [Tab.PAST]: 'Past Challenges',
};

const ChallengeListBlade: React.FC<CType<any>> = ({ fields }) => {
  const router = useRouter();
  const filter: string = (router?.query?.tab ?? '') as string;
  const [industries, setIndustries] = useState<string[]>([]);
  const [selectedIndustry, setSelectedIndustry] = useState<string>();
  const [currentTab, setCurrentTab] = useState<string>(filter || Tab.CURRENT);
  const [currentContent, setCurrentContent] = useState<any>([]);
  const descriptionRef: any = useRef();
  const { past, current, future, pastDescription, currentDescription, futureDescription } = fields;
  useEffect(() => {
    const industryFilter = (challenges: any) => {
      let newChallenges: any = challenges;
      if (selectedIndustry && selectedIndustry !== '') {
        newChallenges = challenges.filter((challenge: any) => {
          const { industryList } = challenge.fields;
          if (industryList) {
            return industryList.fields.title.includes(selectedIndustry);
          }
          return null;
        });
      }
      return newChallenges;
    };
    if (currentTab === Tab.PAST && past?.length > 0) {
      setCurrentContent(industryFilter(past));
      descriptionRef.current = pastDescription;
    }
    if (currentTab === Tab.FUTURE && future?.length > 0) {
      setCurrentContent(industryFilter(future));
      descriptionRef.current = futureDescription;
    }
    if (currentTab === Tab.CURRENT && current?.length > 0) {
      setCurrentContent(industryFilter(current));
      descriptionRef.current = currentDescription;
    }
  }, [
    currentTab,
    past,
    future,
    current,
    pastDescription,
    futureDescription,
    currentDescription,
    selectedIndustry,
  ]);

  useEffect(() => {
    const getList = async () => {
      try {
        const result = await getTagList('industries');
        setIndustries(result ?? []);
      } catch (error) {
        setIndustries([]);
      }
    };
    getList();
  }, []);

  try {
    if ((past?.length || 0) + (current?.length || 0) + (future?.length || 0) === 0) {
      return null;
    }

    const handleClick = (tab: string) => {
      setCurrentTab(tab);
      router.push(
        {
          pathname: `/challenges`,
          query: { tab },
        },
        undefined,
        {
          shallow: true,
        },
      );
    };
    return (
      <div>
        <div className={styles.buttonsContainer}>
          <div className={styles.buttonContainerInner}>
            {[Tab.FUTURE, Tab.CURRENT, Tab.PAST].map(item => (
              <Button
                onlyText
                underline
                onClick={() => handleClick(item)}
                classes={clsx(
                  item === currentTab && styles.tabSelected,
                  (fields[item]?.length || 0) === 0 && styles.buttonDisabled,
                )}
              >
                {ButtonTextMap[item]}
              </Button>
            ))}
            <FilterBar
              primary={[
                {
                  key: 'industryList.fields.title',
                  list: industries,
                  label: 'Select an Industry',
                },
              ]}
              onChange={(key: string, value?: string) => {
                setSelectedIndustry(value);
              }}
              challengePage
            />
          </div>
          {descriptionRef.current && (
            <div className={styles.contentDescription}>
              {descriptionRef.current.content[0].content[0].value}
            </div>
          )}
        </div>
        <div className="is-bgcolor-Blue">
          <div className={clsx('container', styles.cardsContainer)}>
            {currentContent.map((item: any) => (
              <ChallengeCardHorizontal {...item} />
            ))}
          </div>
        </div>
      </div>
    );
  } catch (error) {
    logger.error(error);
    return null;
  }
};
export default ChallengeListBlade;
